<template>
  <div class="h-full">
    <div class="bg-light-gray-400 px-0 py-4 sm:px-4 sm:py-2">
      <h1 class="mx-auto sm:w-full text-black text-center w-[896px]">歷史訂單</h1>
    </div>
    <div class="default-shadow">
      <w-tabs v-model="activeTab" :tabs="tabs" classes="px-5" />
    </div>
    <section
      :class="[orders.length ? 'mt-6' : 'mt-10']"
      class="sm:mt-6 sm:px-4 sm:w-full w-[896px] weiby-container"
    >
      <div v-if="!gettingOrders">
        <template v-if="!orders.length">
          <h2 class="text-xl">
            目前沒有任何訂單，看看
            <router-link
              class="text-primary-500"
              to="/menu"
            >
              訂購首頁
            </router-link>
            有什麼好東西吧！
          </h2>
          <img
            alt="No Orders Image"
            class="mx-auto my-10"
            src="@/assets/images/no-orders-image.jpg"
          />
        </template>
        <template v-else>
          <div class="mb-6">
            <div class="orders__order-count">
              <label class="text-gray-500">訂購次數</label>
              <span class="font-medium text-2xl text-black">{{ orderCount | commaFormat }}</span>
            </div>
            <div
              v-for="(info, infoIndex) in infos"
              :key="`info-${infoIndex}`"
              class="orders__order-infos"
            >
              <label class="text-gray-500">{{ info.label }}</label>
              <span
                :class="info.class"
                class="text-black"
              >
                {{ info.price | commaFormat | priceFormat }}
              </span>
            </div>
          </div>
          <div v-for="groupKey in Object.keys(orderGroups)" :key="groupKey" class="flex gap-x-3">
            <div class="flex flex-col font-medium py-3">
              <span>{{ receiveData(groupKey) }}</span>
              <span>{{ receiveWeek(groupKey) }}</span>
            </div>
            <div class="flex flex-col flex-grow gap-y-3">
              <order-card
                v-for="order in orderGroups[groupKey]"
                :key="order.id"
                :item="order"
                :order-canceled="isOrderCanceled(order)"
                :show-cancel-button="false"
                :show-end-time-string="false"
                class="mb-6"
              >
                <template #header>
                  <div
                    v-if="isOrderCanceled(order)"
                    class="bg-red-50 flex items-center justify-center px-2 py-1 rounded"
                  >
                    <span class="text-red-700 text-xs">此訂購已取消</span>
                  </div>
                </template>
              </order-card>
            </div>
          </div>
        </template>
      </div>
      <w-loading v-else :is-full-page="false" color="primary-500" />
    </section>
  </div>
</template>

<script>
import Orders from './Orders';

export default Orders;
</script>

<style lang="scss" scoped>
@import 'Orders';
</style>
